import { render, staticRenderFns } from "./AuthResetLink.vue?vue&type=template&id=74100639&scoped=true&lang=pug&"
import script from "./AuthResetLink.vue?vue&type=script&lang=js&"
export * from "./AuthResetLink.vue?vue&type=script&lang=js&"
import style0 from "./AuthResetLink.vue?vue&type=style&index=0&id=74100639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74100639",
  null
  
)

export default component.exports